/* iter-51f — Account & Connections dialog (The Loom File menu).
 *
 * Surfaces the user-account level "connect 3rd-party services" UI so
 * authors can log into Canva (and future integrations) from outside the
 * cover-design flow.
 */
import React from 'react';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from '@/components/ui/dialog';
import { UserCog } from 'lucide-react';
import ConnectionsPanel from '@/components/account/ConnectionsPanel';

export default function AccountConnectionsDialog({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl" data-testid="account-connections-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <UserCog className="h-4 w-4 text-primary" /> Account & Connections
          </DialogTitle>
          <DialogDescription>
            Manage the third-party services you've linked to your Crown & Rose
            account. Sign in once here and use them anywhere in the app.
          </DialogDescription>
        </DialogHeader>
        <ConnectionsPanel heading="Linked integrations" />
      </DialogContent>
    </Dialog>
  );
}
